import { render, staticRenderFns } from "./AssetRepairList.vue?vue&type=template&id=4b624d7e"
import script from "./AssetRepairList.vue?vue&type=script&lang=js"
export * from "./AssetRepairList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b624d7e')) {
      api.createRecord('4b624d7e', component.options)
    } else {
      api.reload('4b624d7e', component.options)
    }
    module.hot.accept("./AssetRepairList.vue?vue&type=template&id=4b624d7e", function () {
      api.rerender('4b624d7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/fixed-asset/AssetRepairList.vue"
export default component.exports